import React, { useState, useEffect } from 'react';
import ExportOption from 'components/Common/exportOption';
import ReportsServices from './ReportsServices';
import { format } from 'date-fns';
import { Filter } from 'filter';
import ReportSetting from './ReportSetting';

export default function BasicReport(param: any) {

    let [exportOption, setExportOption] = useState("");
    let [periodList, setPeriodList] = useState<any>([]);
    let [reportingList, setReportList] = useState<any>([]);
    let [selectPeriod, setSelectPeriod] = useState<any>([]);
    let [reportSettings, setreportSettings] = useState(false);
    let [reportSettingData, setreportSettingData] = useState<any>([]);

    useEffect(() => {

        console.log(param);
        var report_type = "type9"

        if (param?.subType && param?.subType == "Statements") {
            report_type = "type1"
        }

        if (param?.subType && param?.subType == "Contracts") {
            report_type = "type2"
        }

        if (param?.subType && param?.subType == "Releases") {
            report_type = "type3"
        }

        if (param?.subType && param?.subType == "Tracks") {
            report_type = "type4"
        }

        if (param?.subType && param?.subType == "Checkings") {
            report_type = "type5"
        }

        if (param?.type && param?.type != "Custom Reports") {
            Report_Listing(report_type)
            get_period();
        }

        if (param?.type && param?.type == "Custom Reports") {
            get_period();

            var payload = [
                { name: "040", description: "040 Master Report", label: "040 Master Report" },
                { name: "050", description: "050 Master Report", label: "050 Master Report" },
                { name: "060", description: "060 Master Report", label: "060 Master Report" }
            ]

            reportingList = payload
            setReportList(reportingList)
        }


    }, [param.type, param.subType]);

    const Report_Listing = (report_type: any) => {

        ReportsServices.ReportListing({ isReportMenu: true }, report_type).then((respond: any) => {
            reportingList = respond
            setReportList(reportingList)
        })
    }

    let [reportSelected, setReportSelected] = useState<any>([]);
    const export_report = (e: any) => {

        console.log(e)
        console.log(selectPeriod)
        reportSelected = e;
        setReportSelected(reportSelected)
        if (param?.subType == "" && param?.type != "Custom Reports") {
            var payload = { type: e.name, periodNum: selectPeriod?.periodDesc }
            ReportsServices.ReportListExport(payload, payload.type)
        }

        if (param?.subType != "" && param?.type != "Custom Reports") {
            var url = 'CrystalReport/viewReport.aspx?report=' + e?.rptFilePath;
            window.open(url);
        }

        if (param?.type == "Custom Reports") {
            exportOption = "open"
            setExportOption(exportOption)
        }
    }

    const get_period = () => {

        ReportsServices.periodCount().then((respond: any) => {
            periodList = respond
            setPeriodList(periodList)

            for (var i = 0; i < respond.length; i++) {
                if (respond[i]?.periodCurrent == 1) {
                    selectPeriod = respond[i]
                    setSelectPeriod(selectPeriod)
                }
            }
        })
    }

    const period_select = (e: any) => {

        var select_p = periodList?.filter((periodList: any) => periodList?.periodDesc == e)
        console.log(select_p)
        console.log(e)
        selectPeriod = select_p[0];
        setSelectPeriod(selectPeriod);
    }

    const closeReportSetting = () => {
        reportSettings = false
        setreportSettings(reportSettings)
    }

    const onChange = (e: any) => {
        console.log(e)
        console.log(reportSelected)

        if (e.optSts === 1) {

            var payload = {
                fileFormat: e.fileFormat,
                fileName: e.fileName,
                numRows: e.numRows,
                report: reportSelected?.name,
                root: "ReportingPack",
                periodNum: selectPeriod?.periodDesc,
            }
            console.log(payload)

            ReportsServices.ReportingPack_Export(payload, e.fileName);
        }

        exportOption = '';
        setExportOption(exportOption)
    }

    const generateReportingPackNew = () => {
        ReportsServices.generate(selectPeriod?.periodDesc)
    }

    return (<>

        <div className='ws-12'>

            <div className='ws-12 box pm mtl'>
                {param?.type != "Custom Reports" && <button className="icon-btn edit pull-right" title="Report Settings" onClick={() => setreportSettings(true)}>
                    <i className="icon-LPurple-Setting m0 p0"></i>
                </button>}

                {param?.type == "Custom Reports" && <button className="icon-btn info pull-right" title="Report Settings" onClick={generateReportingPackNew}>
                    Generate
                </button>}

                {(param?.subType == "" || param?.type == "Custom Reports" || param?.type == "Basic Report") && <select className='ws-2 pull-right' onChange={(e: any) => period_select(e.target.value)}>
                    {
                        periodList?.map((val: any) => {
                            return (<option value={val.periodDesc} label={Filter?.SimplemonthAndDayYear(val?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(val?.periodTo)}></option>)
                        })
                    }

                </select>}

            </div>

            <div className='ws-12 box pm mtl'>

                {reportingList?.map((value: any) => {

                    return (

                        <div className='ws-3 pm'>

                            <div className='ws-12 pull-left height80'>
                                <div className='ws-2'>

                                    <button className='icon-btn info btn-xl' onClick={() => export_report(value)}>
                                        <i className="box icon-reporting1 pbl"></i>
                                    </button>
                                    {<span className="ws-12 mt pll text-bold">{value?.name}</span>}
                                </div>

                                <div className='ws-10'>
                                    <span className="ws-12 mt pll">{param?.subType == "" ? value?.description : value?.label}</span>

                                    <button className='icon-btn edit btn-xs hide'><i className='icon-edit'></i></button>
                                </div>
                            </div>

                        </div>
                    )
                })}

                {reportingList?.length == 0 && <div className="alert alert-info "> No report to display  </div>}
            </div>


            {(() => {
                if (reportSettings) {
                    return <ReportSetting reportSettings={reportSettings} reportingList={reportingList} closeReportSetting={closeReportSetting} />
                }

                if (exportOption && exportOption.length > 0) {
                    return <ExportOption exportOption={exportOption} onChange={onChange} fileName={(param?.type + '_' + reportSelected?.name).replace(/ /g, "")} />
                }
            })()}
        </div>


    </>)
}